/**
 * 由于切换景区和退出登录需要清空数据，避免污染
 * 增删state的内容时要同时维护mutations内的resetState的方法
 * */
export default {
  seller_info: {} // 零售商户信息：用于交账页面
};
